import Vue from 'vue';
import router from '../../router'
import OrganisationCollection from './organisation-collection';
export const WebSocketEvents = new Vue();

let connectionInterval = null;

const connect = async () => {
  if (Socket.ready && (!Socket.websocket || (Socket.websocket && Socket.websocket.readyState === 3))) {
    let token = null;

    if (window.localStorage['userAuth']) {
      var userAuth = JSON.parse(window.localStorage['userAuth'])
      token = `${userAuth.TokenType} ${userAuth.IdToken}`
      // console.log("WEBSOCKET TOKEN",token);
    }

    await AuthSync(true);

    Socket.websocket = new WebSocket(`wss://hyqqzbn751.execute-api.ap-southeast-2.amazonaws.com/prod?Authorization=${token}`);

    Socket.websocket.onmessage = (e) => {
      // console.log("Websocket", e.data);

      try {
        const { type, action, data, sessionChanged = false } = JSON.parse(e.data);
        
        if(type === "notification") {
          console.log("notification", data);
          // NotificationCollection.refresh(true);
          NotificationCollection.add(data);

          if((data?.data?.action?.type || "") === "invite") GroupCollection.refreshInvites();
        } else if(type === "content" && router?.currentRoute?.name === "main.feed") {
          if(action === "show" || action === "hide" || action === "share" || action === "unshare") {
            // FeedCollection.refresh(true);
          }
        } else if(type === "group") {
          if(action === "update") {
            GroupCollection.getDetails(data);
            if(sessionChanged) AuthSync(true);
          } else if(action === "remove") {
            console.log("remove group",data);
            GroupCollection.removeDetails(data);
            if((router?.currentRoute?.params?.groupId || "") === data) router.replace({name: "main.feed"});
            if(sessionChanged) AuthSync(true);
          }
        } else if(type === "user") {
          if(action === "update") {
            if(router?.currentRoute?.params?.groupId && ['main.groups.details','main.group.details'].includes(router?.currentRoute?.name || "")) {
              //group has user
              const user = GroupCollection.getUser(router.currentRoute.params.groupId, data);
              if(user) GroupCollection.getDetails(router.currentRoute.params.groupId);
            }
          }
        } else if(type === "organisation-queue") {
          OrganisationCollection.eventbus.$emit(action, data);
        } else if(type === "chat-notification") {
          console.log("chat-notification", data);
          // NotificationCollection.refresh(true);
          const userId = GetUser()?._id;
          const actionData = data.data.action;
          if(actionData) {
            const notCurrentUser = (actionData.idUser || "") !== userId;

            const groupId = (actionData.groupId || "");
            const isGroupRoute = (router?.currentRoute?.name || "").includes("main.group") && (router?.currentRoute?.name || "").includes(".details") && router?.currentRoute?.query?.tab === "chat";
            const isChatRoute = (router?.currentRoute?.name || "").includes("main.chat.details");

            const isCurrentChat = groupId === router?.currentRoute?.params?.groupId && (isGroupRoute || isChatRoute);

            if(notCurrentUser && !isCurrentChat) {
              console.log("add chat-notification",router?.currentRoute?.params);
              ChatCollection.add(data);
            }

            ChatCollection.getStats();
            ChatCollection.eventbus.$emit(actionData.action, actionData);
          }
        } else if(type === "chat") {
          ChatCollection.getStats();
          ChatCollection.eventbus.$emit(action, data);
        }
      } catch (error) {
        console.log("WebSocket Parse Error", error);
      }
    };

    Socket.websocket.onerror = () => {
      console.log("Websocket: error");
      // Socket.websocket.close();
    };

    Socket.websocket.onopen = () => {
      clearInterval(connectionInterval);
      console.log("Websocket: connected");

      Socket.websocket.onclose = () => {
        if(Socket.ready) {
          console.log("Websocket: connection closed unexpectedly");
          console.log("Websocket: attempting reconnect in 10 seconds");
          connectionInterval = setInterval(() => {
            connect();
          }, 10000);
        }
      };
    };
  }
}

let FeedCollection;
let NotificationCollection;
let GroupCollection;
let ChatCollection;
let AuthSync;
let GetUser;

const Socket = {
  ready: false,
  websocket: null,
  use: ({ feedCollection, notificationCollection, groupCollection, chatCollection, authSync, getUser }) => {
    FeedCollection = feedCollection;
    NotificationCollection = notificationCollection;
    GroupCollection = groupCollection;
    ChatCollection = chatCollection;
    AuthSync = authSync || function() {};
    GetUser = getUser || function() {};
    console.log("Socket Use:",FeedCollection,GroupCollection,ChatCollection,AuthSync);
  },
  init: async () => {
    if (!Socket.ready) {
      console.log("WebSocket init");
      Socket.ready = true;
      connect();
    }
  },
  reset: () => {
    Socket.ready = false;
    if(Socket.websocket) {
      Socket.websocket.close();
      Socket.websocket = null;
      clearInterval(connectionInterval);
    }
    console.log("WebSocket cleared");
  },
  isConnected: () => Socket.ready && Socket.websocket && Socket.websocket.readyState === 1,
  sendMessage: () => {
    Socket.websocket.send(JSON.stringify({data:"hello"}))
  }
}

export default Socket